import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0a1628] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/57dc7616-db30-48df-be75-7723beb17ec9.png" 
              alt="Logo" 
              className="h-10 w-auto mb-6"
            />
            <h4 className="text-lg font-semibold mb-4">레알타드 상담 채널</h4>
            <a 
              href="https://t.me/realtad_cs" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-12 h-12 bg-teal-500 hover:bg-teal-600 rounded-full transition-colors cursor-pointer"
            >
              <i className="ri-telegram-line text-2xl"></i>
            </a>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Menu</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-300 hover:text-teal-400 transition-colors text-sm">회사 소개</Link></li>
              <li><Link to="/solutions" className="text-gray-300 hover:text-teal-400 transition-colors text-sm">솔루션</Link></li>
              <li><Link to="/products" className="text-gray-300 hover:text-teal-400 transition-colors text-sm">제품</Link></li>
              <li><Link to="/customer-stories" className="text-gray-300 hover:text-teal-400 transition-colors text-sm">고객 사례</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-teal-400 transition-colors text-sm">블로그</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-teal-400 transition-colors text-sm">상담하기</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Info</h4>
            <ul className="space-y-3">
              <li><Link to="/terms" className="text-gray-300 hover:text-teal-400 transition-colors text-sm">이용 약관</Link></li>
              <li><Link to="/privacy" className="text-gray-300 hover:text-teal-400 transition-colors text-sm">개인 정보 보호 정책</Link></li>
              <li><Link to="/cookie" className="text-gray-300 hover:text-teal-400 transition-colors text-sm">쿠키 정책</Link></li>
              <li><Link to="/responsible-gambling" className="text-gray-300 hover:text-teal-400 transition-colors text-sm">책임감 있는 게임</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Blog</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/blog/1" className="text-gray-300 hover:text-teal-400 transition-colors text-sm line-clamp-2">
                  토토 솔루션 개발 – 사이트 제작 과정 설명서
                </Link>
              </li>
              <li>
                <Link to="/blog/2" className="text-gray-300 hover:text-teal-400 transition-colors text-sm line-clamp-2">
                  토토 솔루션 업그레이드 기준과 타이밍 – 운영자 필독!
                </Link>
              </li>
              <li>
                <Link to="/blog/3" className="text-gray-300 hover:text-teal-400 transition-colors text-sm line-clamp-2">
                  스포츠북 솔루션 올인원 플랫폼 구축으로 매출 향상
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <p className="text-gray-400 text-sm leading-relaxed mb-4">
            레알타드의 로고 및 그래픽 자료는 회사의 지적 재산이며 어떠한 경우에도 레알타드의 서면 동의 없이 복사, 복제, 배포 또는 표시할 수 없습니다.
            음란 콘텐츠가 포함되어 있거나 다음을 지원하는 웹사이트를 포함하되 이에 국한되지 않는 부적절하거나 유해한 콘텐츠와 관련하여 레알타드의 지적 재산이 표시되어서는 안 됩니다. 
            레알타드는 몰타 게임 당국의 라이선스 MGA/B2B/187/2010에 따라 허가 및 규제를 받습니다. 레알타드는 여러 관할권에서 라이선스 및 규제를 받고 있습니다. 
            레알타드의 개인정보 처리방침은 당사가 개인정보를 처리하는 방법을 설명합니다. 레알타드의 쿠키 정책은 당사가 사용하는 쿠키를 명확히 설명합니다.
            레알타드는 재미있고 안전하며 보안이 유지되는 솔루션을 제공하기 위해 최선을 다하고 있습니다.
          </p>
          <div className="flex flex-col sm:flex-row justify-between items-center text-gray-400 text-sm">
            <p>Copyright © 2025 Realtad. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-teal-400 transition-colors mt-2 sm:mt-0"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
